var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorLog({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1694507668114,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 6021,
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M438.857143 0c234.057143 0 424.228571 190.171429 424.228571 424.228571 0 95.085714-29.257143 175.542857-80.457143 248.685715l204.8 204.8c29.257143 29.257143 29.257143 73.142857 0 102.4-29.257143 29.257143-73.142857 29.257143-102.4 0l-204.8-204.8c-73.142857 51.2-153.6 80.457143-248.685714 80.457143C197.485714 855.771429 7.314286 665.6 7.314286 431.542857S204.8 0 438.857143 0z m51.2 138.971429c-43.885714-7.314286-87.771429-7.314286-131.657143 7.314285-43.885714 7.314286-87.771429 29.257143-124.342857 58.514286-21.942857 14.628571-21.942857 43.885714-7.314286 65.828571 14.628571 14.628571 43.885714 21.942857 65.828572 7.314286 29.257143-21.942857 58.514286-36.571429 87.771428-43.885714 29.257143-7.314286 65.828571-7.314286 95.085714-7.314286 29.257143 7.314286 65.828571 14.628571 87.771429 29.257143 29.257143 14.628571 51.2 36.571429 73.142857 65.828571 14.628571 21.942857 43.885714 21.942857 65.828572 7.314286s21.942857-36.571429 7.314285-58.514286c-21.942857-36.571429-58.514286-65.828571-95.085714-87.771428-43.885714-21.942857-80.457143-36.571429-124.342857-43.885714z",
    fill: "#ffffff",
    "p-id": 6022
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorLog);
export default __webpack_public_path__ + "static/media/error-log.6fff9edc2dbf61ea0442754104add938.svg";
export { ForwardRef as ReactComponent };